import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";
import { Card, CardHeader, CardTitle } from "@/components/ui/card.jsx";
import { useToast } from "@/hooks/use-toast.js";
import routes from "@/routes/routes";
import authAPI from "@/lib/api/auth";

export default function EmailConfirmation() {
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const { toast } = useToast();

  const { key } = useParams();
  const [keyStatus, setKeyStatus] = useState("");

  const onConfirmationSubmit = async () => {
    setIsLoading(true);
    const response = await authAPI.verifyEMailAddress(key);

    switch (response.status) {
      case 200:
        setKeyStatus("valid");
        break;
      case 400:
        setKeyStatus("invalid");
        break;
      case 404:
        setKeyStatus("expired");
        break;
      default:
        console.log("error");
        break;
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (key) onConfirmationSubmit();
  }, [key]);

  const handleKeyStatus = () => {
    const toastConfigs = {
      valid: {
        title: "Email confirmé !",
        description: "Votre compte est activé. Vous pouvez vous connecter.",
        variant: "default",
      },
      invalid: {
        title: "Lien invalide",
        description: "Ce lien de confirmation est corrompu.",
        variant: "destructive",
      },
      expired: {
        title: "Lien expiré",
        description: "Ce lien n'est plus valide.",
        variant: "destructive",
      },
      error: {
        title: "Erreur",
        description: "Une erreur est survenue. Veuillez réessayer plus tard.",
        variant: "destructive",
      },
    };

    const config = toastConfigs[keyStatus] || toastConfigs.error;

    toast({ ...config });

    navigate(routes.account);
  };

  useEffect(() => {
    if (keyStatus) handleKeyStatus();
  }, [keyStatus]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <EmailConfirmationHeader />
          {isLoading && (
            <div className="flex justify-center pt-2">
              <Loader2 className="h-6 w-6 animate-spin text-primary shrink-0" />
            </div>
          )}
        </CardHeader>
      </Card>
    </div>
  );
}

function EmailConfirmationHeader() {
  return (
    <Fragment>
      <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
        <Mail className="h-6 w-6 text-primary" />
      </div>
      <CardTitle className="text-2xl font-bold">
        Confirmation de votre email
      </CardTitle>
    </Fragment>
  );
}
